import { render, staticRenderFns } from "./IDSE.vue?vue&type=template&id=213c22d2&scoped=true"
import script from "./IDSE.vue?vue&type=script&lang=js"
export * from "./IDSE.vue?vue&type=script&lang=js"
import style0 from "./IDSE.vue?vue&type=style&index=0&id=213c22d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c22d2",
  null
  
)

export default component.exports